import Numeral from 'numeral'

export default {
    cash,
    cashRound,
    number,
    percent
}

function cash(value) {
    return Numeral(value).format('$0,0.00')
}

function cashRound(value) {
    return Numeral(value).format('$0,0')
}

function number(value) {
    return Numeral(value).format('0,0')
}

function percent(value) {
    return Numeral(value).format('0.000%')
}